import { required, Spacer, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { alphaNumericValidation } from '@jfs/utils'
import { DatePickerReact } from '../../components/DatePicker'
import { Dropdown } from '../../components/Dropdown'

const textInputStyle = {
  fontSize: 14,
  color: 'BLACK_21',
  placeholderTextColor: 'PRIMARY_GREY',
  borderColor: 'PRIMARY_GREY',
  borderRadius: 4,
  padding: 8,
} as TextInputNewProps
export const formData = (date, isEditable: boolean, updateStatusList: any[], errorDropdown: string) => {
  return [
    {
      formItems: [
        {
          fieldName: 'currentStatus',
          displayName: 'Current Status',
          label: 'Current Status',
          ComponentName: TextInputNew,
          editable: false,
          ...textInputStyle,
        },
        {
          fieldName: 'sp1',
          ComponentName: Spacer,
        },
        {
          fieldName: 'cmsNumber',
          displayName: 'cmsNumber',
          label: 'CMS Number',
          ComponentName: TextInputNew,
          validationSchema: alphaNumericValidation,
          editable: isEditable,
          ...textInputStyle,
        },
        {
          fieldName: 'settlementDate',
          displayName: 'settlementDate',
          label: 'Settlement Date',
          timeInputLabel: 'Select Time',
          showTimeInput: false,
          dateFormat: 'dd/MM/yyyy',
          ComponentName: isEditable ? DatePickerReact : Text,
          dateValue: date ? new Date(date) : new Date(),
          validationSchema: required,
          from: 'ess',
        },
        {
          fieldName: 'spacer1',
          ComponentName: Spacer,
        },
        {
          fieldName: 'status',
          ComponentName: Dropdown,
          selectable: isEditable,
          title: 'Update Status',
          label: 'Update Status',
          data: updateStatusList,
          validationSchema: required,
          error: errorDropdown,
          touched: errorDropdown?.length > 0,
        },
        {
          fieldName: 'spacer2',
          ComponentName: Spacer,
        },
        {
          fieldName: 'remarks',
          displayName: 'remarks',
          label: 'Remarks',
          editable: isEditable,
          ComponentName: TextInputNew,
          ...textInputStyle,
        },
        {
          fieldName: 'spacer3',
          ComponentName: Spacer,
        },
      ],
      onSubmit: () => {
        return ''
      },
    },
  ]
}
